/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

/* components */
import SessionsForm from "./SessionsForm";
import Page from "../../shared/Page";
import GetItem from "../../../helpers/dataProviders/getItem";

class SessionsFormWrapper extends Component {
	constructor(props) {
		super(props);
		this.indefiniteArticle = "A";
		this.label = "Session";
		this.id = props.match.params.id ? props.match.params.id : 0;
		this.state = {
			item: null,
		};
	}

	submitForm(values, submitHandler, id = "") {
		const { createItem, copyItem, updateItem, type } = this.props;
		switch (type) {
			case "new":
				createItem(values, submitHandler);
				break;
			case "copy":
				copyItem(values, submitHandler);
				break;
			case "update":
				updateItem(values, submitHandler, id);
				break;
			default:
				break;
		}
	}

	renderCreateForm = () => {
		const {
			location: { state: locationState },
		} = this.props;

		let initialValues = {
			kind: "simple",
			...locationState,
		};

		return (
			<div className="ta-center">
				<h3 className="page-title">
					Create {this.indefiniteArticle} {this.label}
				</h3>
				<SessionsForm
					onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler)}
					buttonLabel={`Create ${this.label}`}
					initialValues={initialValues}
					topics={this.props.topics}
					getApi={this.props.getApi}
					sessions={this.props.items}
				/>
			</div>
		);
	};

	renderCopyForm = () => {
		const { item } = this.state;
		if (item === null) {
			GetItem(`/sessions/${this.props.match.params.id}`).then(data => {
				this.setState({ item: data.data });
			});
		}
		let initialValues = {};
		if (item) {
			initialValues = Object.assign({}, item);
			if (item.alertMinutesBefore) {
				initialValues = Object.assign({}, item, { reminder: "yes" });
			}
		}
		return (
			<div className="ta-center">
				<h3 className="page-title">
					Copy {this.indefiniteArticle} {this.label}
				</h3>
				{item ? (
					<SessionsForm
						onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler, this.state.item.id)}
						initialValues={initialValues}
						buttonLabel={`Create ${this.label}`}
						topics={this.props.topics}
						getApi={this.props.getApi}
						sessions={this.props.items}
					/>
				) : (
					"Loading..."
				)}
			</div>
		);
	};

	renderUpdateForm = () => {
		const { item } = this.state;
		if (item === null) {
			GetItem(`/sessions/${this.props.match.params.id}`).then(data => {
				this.setState({ item: data.data });
			});
		}
		let initialValues = {};
		if (item) {
			initialValues = Object.assign({}, item);
			if (item.alertMinutesBefore) {
				initialValues = Object.assign({}, item, { reminder: "yes" });
			}
		}
		return (
			<div className="ta-center">
				<h3 className="page-title">
					Update {this.indefiniteArticle} {this.label}
				</h3>
				{item ? (
					<SessionsForm
						onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler, this.state.item.id)}
						initialValues={initialValues}
						buttonLabel={`Update ${this.label}`}
						topics={this.props.topics}
						getApi={this.props.getApi}
						sessions={this.props.items}
						id={this.state.item.id}
						actionType="update"
					/>
				) : (
					"Loading..."
				)}
			</div>
		);
	};

	render() {
		let content = "";
		switch (this.props.type) {
			case "new":
				content = this.renderCreateForm();
				break;
			case "copy":
				content = this.renderCopyForm();
				break;
			case "update":
				content = this.renderUpdateForm();
				break;
			default:
				content = "loading";
				break;
		}
		return <Page title="My Sessions">{content}</Page>;
	}
}

SessionsFormWrapper.propTypes = {
	type: PropTypes.string,
	items: PropTypes.array,
	createItem: PropTypes.func,
	copyItem: PropTypes.func,
	updateItem: PropTypes.func,
	match: PropTypes.object,
	topics: PropTypes.array,
	getApi: PropTypes.func,
};

export default withRouter(SessionsFormWrapper);
